var tabsItem = 'fx_c76f37be_qq1dk54';
var tabsItemHorizontalGap = 'var(--fx_c76f37be_qq1dk51)';

export { tabsItem, tabsItemHorizontalGap };
//# sourceMappingURL=item.vanilla.mjs.map
